import _mergeJSXProps from "babel-helper-vue-jsx-merge-props";
export default {
  name: 'W4',
  functional: true,
  render: function (h, ctx) {
    return h(
      "svg",
      _mergeJSXProps([{
        attrs: { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }
      }, ctx.data]),
      [h("path", {
        attrs: { d: "M30.55 24.73H1.45a1.451 1.451 0 0 1 0-2.9h29.09c.8 0 1.45.65 1.45 1.45.01.8-.64 1.45-1.44 1.45zm0-5.82H1.45c-.8 0-1.45-.65-1.45-1.45C0 16.65.65 16 1.45 16h29.09c.8 0 1.45.65 1.45 1.45.01.81-.64 1.46-1.44 1.46zm-7.28-8.73c-1.16 0-2.24.35-3.15.94-.9-3.87-4.35-6.76-8.48-6.76-4.82 0-8.73 3.91-8.73 8.73H0C0 6.67 5.21 1.45 11.64 1.45c4.37 0 8.17 2.41 10.16 5.97.48-.08.97-.15 1.48-.15 3.8 0 7.02 2.43 8.22 5.82h-3.19a5.824 5.824 0 0 0-5.04-2.91zM1.45 27.64h29.09a1.451 1.451 0 0 1 0 2.9H1.45a1.451 1.451 0 0 1 0-2.9z" }
      })]
    );
  }
};